import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntegracionesRoutingModule } from './integraciones-routing.module';
import { IntegracionesComponent } from './integraciones.component';
import { MaterialModule } from '../material/material.module';
import { PropuestasService } from '../../providers/propuestas.service';

@NgModule({
  declarations: [IntegracionesComponent],
  imports: [
    CommonModule,
    IntegracionesRoutingModule,
    MaterialModule,
  ],
  providers: [
    PropuestasService
  ]
})
export class IntegracionesModule { }
